import { useEffect, useState } from "react";
import { fetchClients } from "../../api";
import styles from "./ClientList.module.scss";
import { images_path } from "../../constants";

const ClientList = () => {
  const [clients, setClients] = useState([]);

  const [editClientId, setEditClientId] = useState(-1);

  useEffect(() => {
    fetchClients().then((data) => {
      setClients(data);
    });
  }, []);

  const displayField = (label, field) => {
    return (
      <div>
        <span style={{ fontWeight: "500" }}>{label}:</span> <span>{field}</span>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      {clients.map((client) => {
        return (
          <div key={client.id} className={styles.client_container}>
            {/*<button
              onClick={() => setEditClientId(client.id)}
              className={styles.edit_button}
            >
              <img
                className={styles.edit_icon}
                src={images_path + "edit.svg"}
              ></img>
            </button>*/}
            <span className={styles.client_name}>{client.name}</span>
            {displayField("Indirizzo", client.address)}
            {displayField("Telefono", client.phone)}
            {displayField("E-mail", client.email)}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.25rem",
              }}
            >
              <span style={{ fontWeight: "500" }}>Referenti:</span>
              {client.representatives.map((referent) => {
                return (
                  <span style={{ paddingLeft: ".5rem" }} key={referent.id}>
                    {referent.name}
                  </span>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ClientList;
